import React from "react";
import {
  CChatBox1,
  CChatBox2,
  Contact,
  Dashboard,
  Doc,
  Forget,
  Home,
  Login,
  Pricing,
  Privacy,
  Refund,
  Shipping,
  Signup,
  Support,
  Terms,
} from "./pages";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import ProtectedRoute from "./ProtectRoter";
import PaymentSuccess from "./pages/dashboard/component/AccoundSettings/PaymentSuccess";
import AuthCallback from "./components/AuthCallback";
import ChatLauncher from "./pages/Ccharbox3/ChatLauncher";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/doc" element={<Doc />} />
        <Route path="/legal/privacy" element={<Privacy />} />
        <Route path="/legal/terms" element={<Terms />} />
        <Route path="/legal/refund" element={<Refund />} />
        <Route path="/legal/ship" element={<Shipping />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contacts" element={<Contact />} />
        <Route path="/support" element={<Support />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forget" element={<Forget />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/chatapp/:userId/:botID/:reranking/:queryexpanstion"
          element={<CChatBox2 />}
        />
        <Route
          path="/test"
          element={<ChatLauncher />} />

        <Route
          path="/v2/chatapp/:userId/:botID/:reranking/:queryexpanstion"
          element={<CChatBox1 />}
        />
        <Route path="/success" element={<PaymentSuccess />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
